<template>
  <div>
    <Toast position="top-right" />
    <b-modal
      id="faq-modal-center"
      centered
      no-close-button
      no-close-on-backdrop
      no-close-on-esc
      hide-header
      hide-footer
      size="lg"
    >
      <template #default="{ ok, cancel }">
        <div class="d-flex justify-content-between">
          <div>
            <h5 class="">Base de conhecimentos (FAQ)</h5>
            <p class="" style="font-size: 0.85rem; color: #949494">
              Preencha a base de conhecimentos de perguntas frequentes para
              treinar a IA
            </p>
          </div>
          <i
            style="cursor: pointer"
            @click="$bvModal.hide('faq-modal-center')"
            class="fa-solid fa-xmark text-dark"
          ></i>
        </div>

        <div class="mt-3">
          <h6 style="font-size: 0.95rem">Pergunta</h6>
          <b-form-input
            id="input-1"
            v-model="faq_payload.pergunta"
            :class="{
              'is-invalid':
                faq_payload.pergunta && faq_payload.pergunta.length < 15
            }"
          ></b-form-input>
          <b-form-invalid-feedback>
            A pergunta deve ter ao mínimo 15 caracteres.
          </b-form-invalid-feedback>
        </div>
        <div class="mt-3">
          <h6 style="font-size: 0.95rem">Resposta</h6>
          <b-form-textarea
            id="textarea"
            v-model="faq_payload.resposta"
            rows="12"
            no-resize
          ></b-form-textarea>
        </div>

        <div class="d-flex justify-content-between mt-4">
          <div class="d-flex align-items-center">
            <h6 style="font-size: 0.95rem" class="mt-3">Status da pergunta:</h6>
            <b-form-checkbox
              v-model="faq_payload.ativa"
              name="check-button"
              class="custom-switch custom-switch-color pt-0 ml-2"
              switch
              size="lg"
            ></b-form-checkbox>
          </div>
          <div>
            <button
              class="mr-2 p-2"
              @click="cancel()"
              style="
                border: 1px solid #472282;
                border-radius: 5px;
                color: #472282;
                cursor: pointer;
              "
            >
              Cancelar
            </button>
            <button
              class="mr-2 p-2"
              style="
                border: 1px solid #472282;
                border-radius: 5px;
                background-color: #472282;
                color: white;
              "
              :disabled="
                !faq_payload.pergunta ||
                faq_payload.pergunta.length < 15 ||
                !faq_payload.resposta
              "
              @click="handleSubmitFAQ"
              @keydown.enter.prevent="handleSubmitFAQ"
            >
              Salvar
            </button>
          </div>
        </div>
      </template>
    </b-modal>
    <div class="card p-6">
      <div class="">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <div class="d-flex align-items-center">
            <h4 class="mr-2 mb-0">Base de conhecimentos (FAQ)</h4>
            <Tooltip
              message="As perguntas frequentes são utilizadas para educar a Letícia, que ficará responsável por tirar todas as dúvidas dos seus clientes sobre a sua clínica"
            />
          </div>
          <div>
            <span class="p-input-icon-left mr-3">
              <i class="pi pi-search" />
              <InputText
                type="text"
                placeholder="Buscar pergunta"
                v-model="busca_faq"
                @input="buscarFAQ"
              />
            </span>
            <button
              @click="abrirModalFormFAQ(null)"
              style="
                background-color: #472282;
                color: white;
                border-radius: 4px;
                padding: 7.5px 16px;
              "
            >
              Adicionar Pergunta
            </button>
            <b-button
              variant="outline-secondary"
              class="b-button-custom ml-2"
              v-b-toggle.filtros
            >
              <i class="fas fa-filter"></i> Filtros
            </b-button>
            <transition
              enter-active-class="animate__animated animate__fadeIn animate__faster"
            >
              <button
                v-if="selectedFaqs.length"
                style="
                  background-color: #eb0000;
                  color: white;
                  border-radius: 4px;
                  padding: 7.5px 16px;
                  transition: all 0.2s ease-in-out;
                "
                class="ml-2"
                @click="deletarSelecionadosFAQ"
              >
                Excluir Selecionados
              </button>
            </transition>
          </div>
        </div>

        <br />
        <b-collapse id="filtros" class="mb-4">
          <div class="d-flex">
            <div>
              <h6>Status</h6>
              <Dropdown
                v-model="filtro_status"
                :options="filtro_status_options"
                optionLabel="name"
                optionValue="value"
                placeholder="Selecione o status"
                style="width: 200px"
                @change="buscarFAQ"
              />
            </div>
          </div>
        </b-collapse>
        <div class="d-flex align-items-center ml-5" style="height: 35px">
          <div v-if="selectedFaqs.length">
            <Checkbox id="multiSelectedId" v-model="selectedAll" binary />
            <label for="multiSelectedId" class="mb-0 ml-2"
              >Selecionar Todos</label
            >
          </div>
        </div>
        <ul class="list-group">
          <li
            class="faq-item-container"
            :class="{ active: faq.cof_ativa }"
            v-for="(faq, idx) in faqs_filtrados"
            :key="faq.conta_faq_id"
          >
            <div class="flexer w-100">
              <div>
                <Checkbox v-model="selectedFaqs" :value="faq.conta_faq_id" />
              </div>
              <div class="faq-idx-container">
                <p class="pergunta-numero d-flex justify-content-center">
                  {{ calculateFAQIdx(idx) }}
                </p>
              </div>
              <div>
                <b-form-checkbox
                  v-model="faq.cof_ativa"
                  name="check-button"
                  class="custom-switch custom-switch-color pt-0"
                  switch
                  size="lg"
                  @change="mudancaStatusFAQ(faq)"
                >
                </b-form-checkbox>
              </div>
              <div class="w-100">
                <p class="pergunta">{{ faq.cof_pergunta }}</p>
                <p class="resposta">{{ faq.cof_resposta }}</p>
              </div>
            </div>
            <div class="acoes-container">
              <div class="editar" @click="abrirModalFormFAQ(faq)">
                <i class="fa-solid fa-pen" />
              </div>
              <div class="remover" @click="deletarFAQ(faq)">
                <i class="fa-solid fa-trash"></i>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ApiService from "@/core/services/api.service";
import API_LINKS from "../automacao/api.links";
import Swal from "sweetalert2";
import Dropdown from "primevue/dropdown";

export default {
  name: "FAQ",
  components: {
    Toast: () => import("primevue/toast"),
    Tooltip: () => import("@/view/pages/painel/dashboard/Tooltip.vue"),
    InputText: () => import("primevue/inputtext"),
    Checkbox: () => import("primevue/checkbox"),
    Dropdown
  },
  data() {
    return {
      faqs_conta: [],
      faqs_filtrados: [],
      busca_faq: "",
      filtro_status: null,
      filtro_status_options: [
        { name: "Todos", value: null },
        { name: "Ativo", value: true },
        { name: "Inativo", value: false }
      ],
      faq_payload: {
        pergunta: "",
        resposta: "",
        ativa: true
      },
      selectedAll: false,
      selectedFaqs: []
    };
  },
  methods: {
    buscarFAQ() {
      this.faqs_filtrados = this.faqs_conta
        .filter((faq) => {
          const tem_na_pergunta = faq.cof_pergunta
            .toLowerCase()
            .includes(this.busca_faq.toLowerCase());

          const tem_na_resposta = faq.cof_resposta
            ?.toLowerCase()
            .includes(this.busca_faq.toLowerCase());

          return tem_na_pergunta || tem_na_resposta;
        })
        .filter((faq) => {
          if (this.filtro_status === null) {
            return true;
          }
          return faq.cof_ativa === this.filtro_status;
        });
      this.selectedFaqs = [];
    },
    async handleSubmitFAQ() {
      if (this.faq_payload.conta_faq_id) {
        return await this.editarFAQ();
      }
      const payload = {
        faq: {
          ...this.faq_payload
        }
      };

      await ApiService.post(API_LINKS.faq, payload);
      Swal.fire({
        title: "Pergunta cadastrada com sucesso!",
        icon: "success",
        showConfirmButton: false,
        timer: 500
      });
      this.getFAQs();
      this.$bvModal.hide("faq-modal-center");
    },
    async editarFAQ() {
      const payload = {
        faq: {
          ...this.faq_payload
        }
      };
      await ApiService.put(API_LINKS.faq, payload);
      this.getFAQs();
      Swal.fire({
        title: "Pergunta editada com sucesso!",
        icon: "success",
        showConfirmButton: false,
        timer: 500
      });
      this.$bvModal.hide("faq-modal-center");
    },
    async getFAQs() {
      const faqs = await ApiService.get(API_LINKS.faq);
      const active_faqs = faqs.data.faqs.filter((faq) => faq.cof_ativa);
      const inactive_faqs = faqs.data.faqs.filter((faq) => !faq.cof_ativa);
      active_faqs.sort((a, b) => {
        return a.conta_faq_id - b.conta_faq_id;
      });
      inactive_faqs.sort((a, b) => {
        return new Date(b.cof_data_cadastro) - new Date(a.cof_data_cadastro);
      });
      this.faqs_conta = [...active_faqs, ...inactive_faqs];
      this.buscarFAQ();
    },
    async deletarFAQ(faq) {
      // Swal.fire({
      //   title: "Deseja realmente deletar esta pergunta?",
      //   showCancelButton: true,
      //   confirmButtonText: "Sim",
      //   cancelButtonText: "Não",
      //   customClass: {
      //     cancelButton: "btn btn-secondary",
      //     confirmButton: "btn btn-danger"
      //   },
      //   buttonsStyling: false
      // })
      Swal.fire({
        title: "<strong>Deseja excluir esta pergunta?</strong>",
        html: "Esta pergunta será permanentemente excluída e não poderá ser recuperada, mas você poderá criá-la novamente a qualquer momento.",
        showCancelButton: true,
        confirmButtonText: "Excluir",
        cancelButtonText: "Cancelar",
        customClass: {
          container: "wellon-alerta",
          popup: "meu-alerta",
          title: "meu-titulo",
          htmlContainer: "meu-texto",
          cancelButton: "btn-cancelar",
          confirmButton: "btn-excluir"
        },
        buttonsStyling: false,
        reverseButtons: true
      }).then(async (result) => {
        if (result.value) {
          const payload = {
            conta_faq_id: [faq.conta_faq_id]
          };
          await ApiService.delete(API_LINKS.faq, payload);
          await this.getFAQs();
          Swal.fire({
            title: "Pergunta deletada com sucesso!",
            icon: "success",
            showConfirmButton: false,
            timer: 500
          });
        }
      });
    },
    async deletarSelecionadosFAQ() {
      Swal.fire({
        title: "<strong>Deseja excluir todas selecionadas?</strong>",
        html: "Essas perguntas serão excluídas permanentemente e não poderão ser recuperadas, mas você pode criá-las novamente quando quiser.",
        showCancelButton: true,
        confirmButtonText: "Excluir selecionadas",
        cancelButtonText: "Cancelar",
        customClass: {
          container: "wellon-alerta",
          popup: "meu-alerta",
          title: "meu-titulo",
          htmlContainer: "meu-texto",
          cancelButton: "btn-cancelar",
          confirmButton: "btn-excluir"
        },
        buttonsStyling: false,
        reverseButtons: true
      }).then(async (result) => {
        if (result.value) {
          const payload = {
            conta_faq_id: this.selectedFaqs
          };
          await ApiService.delete(API_LINKS.faq, payload);
          await this.getFAQs();
          Swal.fire({
            title: "Pergunta deletada com sucesso!",
            icon: "success",
            showConfirmButton: false,
            timer: 500
          });
        }
      });
    },
    calculateFAQIdx(idx) {
      return idx + 1 < 10 ? `0${idx + 1}` : idx + 1;
    },
    async abrirModalFormFAQ(faq) {
      if (!faq) {
        this.faq_payload = {
          pergunta: "",
          resposta: "",
          ativa: true
        };
      } else {
        this.faq_payload = {
          pergunta: faq.cof_pergunta,
          resposta: faq.cof_resposta,
          ativa: faq.cof_ativa,
          conta_faq_id: faq.conta_faq_id
        };
      }
      this.$bvModal.show("faq-modal-center");
    },
    async mudancaStatusFAQ(faq) {
      const payload = {
        ativa: faq.cof_ativa,
        conta_faq_id: faq.conta_faq_id,
        pergunta: faq.cof_pergunta,
        resposta: faq.cof_resposta
      };
      await ApiService.put(API_LINKS.faq, { faq: payload }).finally(() => {
        this.getFAQs();
      });
    }
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Chatbot"
      },
      {
        title: "FAQ",
        route: "/painel/chatbot/faq"
      }
    ]);
    const init = async () => {
      this.getFAQs();
    };
    init();
  },
  computed: {
    multiSelected() {
      return this.faqs_filtrados?.some((faq) => faq?._selected);
    },
    // todosSelecionados: {
    //   get() {
    //     return this.faqs_filtrados?.every((faq) => faq?._selected);
    //   },
    //   set(value) {
    //     this.selectedAll = value;
    //     this.faqs_filtrados.forEach((faq) => (faq._selected = value));
    //   }
    // }
    todosSelecionados() {
      return this.faqs_filtrados?.every((faq) => faq?._selected);
    }
  },
  watch: {
    // todosSelecionados(newValue) {
    //   this.selectedAll = newValue;
    // },
    selectedAll(newValue) {
      const todos = this.faqs_filtrados.map((i) => i.conta_faq_id);
      this.selectedFaqs = newValue ? todos : [];
    }
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300&display=swap");

.p-togglebutton.p-button {
  background: #e4e6ef;
  border: 1px solid #ced4da;
  color: #495057 !important;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s,
    box-shadow 0.2s;
  text-transform: uppercase;
}

.p-togglebutton.p-button:not(.p-disabled):not(.p-highlight):hover {
  background: #f8f9fa;
  border: 1px solid #ced4da;
  color: #495057 !important;
}

.p-togglebutton.p-button.p-highlight {
  background: #e8f3d6;
  border-color: #e8f3d6;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s,
    box-shadow 0.2s;
}

.faq-item-container {
  display: flex;
  height: 75px;
  background: #eeeeee;
  opacity: 0.5;
  border: 1px solid #adb5bd;
  &.active {
    background: white;
    border-color: #dcdfe3;
    opacity: 1;
  }
  border-radius: 4px !important;
  align-items: center;
  justify-content: space-betweens;
  width: 100%;
  padding: 1rem;
  margin-bottom: 1rem;
  p {
    margin: 0;
  }
  .flexer {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
  .acoes-container {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    div {
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .editar {
      border: 1px solid #dcdfe3;
      border-radius: 4px;
      i {
        font-size: 1rem;
        color: #404254 !important;
      }
    }
    .remover {
      border: 1px solid #dcdfe3;
      border-radius: 4px;
      i {
        font-size: 1rem;
        color: #404254 !important;
      }
    }
  }
  .faq-idx-container {
    font-size: 1.8rem;
    width: 60px;
    .pergunta-numero {
      color: #472282;
      margin: 0;
      width: 100%;
    }
  }
  .pergunta {
    font-size: 1rem;
    font-weight: 600;
    color: #000;
    margin: 0;
  }
  .resposta {
    font-size: 0.9rem;
    width: 95%;
    color: #000;
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: keep-all;
  }
}

.novo-menu-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border: 1px dashed #000;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  width: 100%;
  height: 59px;
  &:hover {
    background: #eee;
    color: #000;
  }
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #472282;
  background-color: #472282;
}

.wellon-alerta .meu-alerta {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 0.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  text-align: left;
}

.wellon-alerta .meu-titulo {
  font-weight: 600;
  font-size: 1.25rem;
  color: #333;
}

.wellon-alerta .meu-texto {
  color: #6c757d;
  font-size: 0.95rem;
  margin-top: 0.5rem;
  padding: 0;
}

.wellon-alerta .btn-cancelar {
  background-color: #fff;
  border: 1px solid #6f42c1;
  color: #6f42c1;
  border-radius: 6px;
  padding: 0.5rem 1.25rem;
  font-weight: 500;
  margin-right: 0.5rem;
}

.wellon-alerta .btn-excluir {
  background-color: #6f42c1;
  border: 1px solid #6f42c1;
  color: white;
  border-radius: 6px;
  padding: 0.5rem 1.25rem;
  font-weight: 500;
}

.wellon-alerta .swal2-header {
  display: block;
  text-align: left !important;
}

.wellon-alerta .swal2-content {
  display: block;
  text-align: left !important;
}

.wellon-alerta .swal2-actions {
  display: flex;
  justify-content: flex-end;
  padding-right: 1rem;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease-in-out;
}

// .v-enter-from,
// .v-leave-to {
//   opacity: 0;
// }
</style>
